import React from 'react';
import BankFormPage from './BankFormPage';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const BankEdit: React.FC<ShowAlerts> = () => <BankFormPage mode="edit" />;

export default BankEdit;
